module.exports = __webpack_public_path__ + "static/media/tahmid.391898f6.jpeg";